import React, { ReactElement, useEffect, useState } from 'react';
import './DoctorImage.less';
import { ReactComponent as ApprovedIcon } from '../../../assets/images/svg/i_approved.svg';
import { ReactComponent as PendingIcon } from '../../../assets/images/svg/i_pending.svg';
import { ReactComponent as RejectedIcon } from '../../../assets/images/svg/i_rejected.svg';
import { StatusFilterType } from '../../constants/commonConstants';
import { useForceUpdate } from '../../hooks/useForceUpdate';

function DoctorImage({ imgUrl, customeClass, noVerifyIcon, status, gender, directSrc }: any): ReactElement {
  const [defaultUrl, setDefaultUrl] = useState(require('../../../assets/images/svg/i_contact.svg'));
  const [isImgValid, setIsImgValid] = useState(true);
  const forceUpdate = useForceUpdate();

  const setDefaultImage = (): void => {
    if (gender === 'Male') {
      setDefaultUrl(require('../../../assets/images/svg/i_male_doctor.svg'));
    } else if (gender === 'Female') {
      setDefaultUrl(require('../../../assets/images/svg/i_female_doctor.svg'));
    } else {
      setDefaultUrl(require('../../../assets/images/svg/i_contact.svg'));
    }
  };

  useEffect((): any => {
    setDefaultImage();
  }, []);

  useEffect((): any => {
    forceUpdate();
  }, [imgUrl]);

  return (
    <div className="doct-img">
      {
        imgUrl && isImgValid ?
          <img
            src={directSrc ? imgUrl : `data:image/jpeg;base64,${imgUrl}`}
            alt="Doctor"
            className={'doct ' + (customeClass ? customeClass : '')}
            onError={(): any => setIsImgValid(false)}
          /> :
          <img
            src={defaultUrl}
            className={'doct ' + (customeClass ? customeClass : '')}
          />
      }
      { !noVerifyIcon &&
        <>
          {
            status === StatusFilterType.isApproved ? <ApprovedIcon className="status fill-sucess" />
              : status === StatusFilterType.isSubmit ? <PendingIcon className="status fill-pending" /> : status === 'none' ? '' :
                <RejectedIcon className="status fill-rejected" />
          }
        </>
      }

    </div>
  );
}

export default DoctorImage;
